module.exports = __webpack_public_path__ + "static/media/no_standing.df3bc469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/parking_icons/no_standing.png
// module id = 1277
// module chunks = 0 1